/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { BaseApi } from './BaseApi';
import { Observable } from 'rxjs';

export class AuthApi extends BaseApi {
  endPoint: string = '/api/auth';

  public getCurrentUser() {
    return this._get('/api/admin/users/current', {})
  }

  public provision(credentials: { email: string }): Observable<any> {
    const _routeParams: any = {};
    return this._post('/api/admin/auth/provision', _routeParams, credentials);
  }

  public logout(): Observable<any> {
    const _routeParams: any = {};
    return this._get('/api/auth/logout', _routeParams);
  }

  public verify(id: any): Observable<any> {
    const _routeParams: any = {
      id: id
    };
    const _postBody: any = {};
    return this._post('/api/users/:id/verify', _routeParams, _postBody);
  }

  public setPassword(password: any, token: string): Observable<any> {
    this._post('/api/auth/reset-password', {}, {
      plainPassword: password,
      token: token
    });
    return;
  }
}
